module.exports = __webpack_public_path__ + "files/SPIADI2025 - TOP CVP - Fiche Service (Version 2).a969d4d1a8e1a78bbac4a733ae3daeec.pdf";